$(document).ready(function($) {

	//play pause add class
	//set progress bar

	$(document).on("click", ".client-view-content .play-btn", function() {
		if ($("html").hasClass('video-playing')) {
			$(this).closest("html").removeClass('video-playing').find('video').trigger('pause');
		} else {
			$(this).closest("html").addClass('video-playing').find('video').trigger('play');
		}
	});

	//pause on end
	$('.video-container video').on('ended', function() {
		$(this).closest("html").removeClass('video-playing');
	});

	$(document).on("click", ".slideout-video .play-btn", function() {

		// var videoID = $(this).closest(".slideout-video").find("video");
		// var v_source = $("videoID").children("source");
		// $('v_source').attr({
		// 	src: $('videoID').attr('data-src')

		// }).removeAttr('data-src');	

		$("#video-progress-bar1 span").each(function(){
			$(this).css("width", "0%");
		});   

		if ($(".slideout-video").hasClass('video-playing')) {
			$(this).closest(".slideout-video").removeClass('video-playing').find('video').trigger('pause');
		} else {
			$(this).closest(".slideout-video").addClass('video-playing').find('video').trigger('play');
		}

		var vid = $(this).closest(".slideout-video").find("video");
                
		vid = vid[0];
                //disable right click on video
                $(vid).bind("contextmenu",function(){
                    return false;
                });
		vid.ontimeupdate = function() {
			var percentage = (vid.currentTime / vid.duration) * 100;

			$("#video-progress-bar1 span").each(function(){
				$(this).css("width", percentage + "%");
			});    
		};

		$('.slideout-video video').on('ended', function() {
			$(this).closest(".slideout-video").removeClass('video-playing');
		});
	});

	if ($(".client-view-content").length) {
	//set playbutton from left
	var left_distance = $(".client-view-content .client-view-text").offset().left - ($(".client-view-content .video-container").offset().left + $(".client-view-content .video-container").width()) + ($(".client-view-content .play-btn").width() / 2);
		
		$(".video-tool-wrap").css("left", -left_distance);

		//set progress bar
		var vid = document.getElementById("video");
                //disable right click on video
                $(vid).bind("contextmenu",function(){
                    return false;
                });
		vid.ontimeupdate = function() {
			var percentage = (vid.currentTime / vid.duration) * 100;
			$(".video-progress-bar span").css("width", percentage + "%");
		};
	}
});

$(window).on("resize", function(event) {
	if ($(".client-view-content").length) {
		var left_distance = $(".client-view-content .client-view-text").offset().left - ($(".client-view-content .video-container").offset().left + $(".client-view-content .video-container").width()) + ($(".client-view-content .play-btn").width() / 2);
		$(".video-tool-wrap").css("left", -left_distance)
	}
})
//disable right click on video